import React from 'react'
import { Box, List, ListItem, Typography } from '@mui/material'

import { FormProps } from '../DynamicInputForm'
import Image from '../Image'

import { SignupForm } from './SignupForm'

type TestimonialsProps = {
  data: {
    title: string
    customer_logos: {
      _key: string
      asset: {
        url: string
      }
    }[]
    form_input_single_row: FormProps['formProps']
    testimonial: {
      clientname: string
      clientdesignation: string
      clientcontent: string
      clientimage: {
        asset: {
          url: string
        }
      }
    }
  }
}

export const Testimonials = ({ data }: TestimonialsProps) => (
  <Box
    sx={{
      pt: { xs: 5.5, mobile: 11, laptop: 12 }
    }}>
    <Box
      sx={{
        display: { laptop: 'flex' },
        maxWidth: 1152,
        mx: 'auto',
        pb: { xs: 8, mobile: 10, laptop: 12 },
        px: {
          xs: 3,
          mobile: 8,
          laptop: 4,
          desktop: 0
        }
      }}>
      <Box sx={{ width: { laptop: '50%' }, mr: { laptop: 20 } }}>
        <Typography
          variant='h1'
          component='h2'
          sx={{
            fontSize: { laptop: 54 },
            letterSpacing: '-0.04em',
            mt: { laptop: 8 },
            textAlign: { xs: 'center', laptop: 'left' }
          }}>
          {data.title}
        </Typography>

        <Box
          sx={{
            alignItems: { xs: 'center', laptop: 'flex-start' },
            display: 'flex',
            flexDirection: { xs: 'column', laptop: 'column-reverse' }
          }}>
          <Box sx={{ width: '100%' }}>
            <List
              disablePadding
              sx={{
                display: 'flex',
                gap: 4,
                justifyContent: 'space-between',
                maxWidth: { laptop: 394 },
                mr: { mobile: 12, laptop: 9 },
                mt: { xs: 4, mobile: 7.5, laptop: 6 }
              }}>
              {data.customer_logos.slice(0, 3).map(item => (
                <ListItem
                  key={item._key}
                  disablePadding
                  sx={{ width: 'fit-content', maxWidth: 150 }}>
                  <Image url={item.asset?.url} />
                </ListItem>
              ))}
            </List>

            <List
              disablePadding
              sx={{
                display: 'flex',
                gap: 4,
                justifyContent: 'space-between',
                maxWidth: { laptop: 394 },
                mt: { xs: 2.5, mobile: 5 },
                ml: { mobile: 12, laptop: 9 }
              }}>
              {data.customer_logos.slice(3, 6).map(item => (
                <ListItem
                  key={item._key}
                  disablePadding
                  sx={{ width: 'fit-content', maxWidth: 150 }}>
                  <Image url={item.asset?.url} />
                </ListItem>
              ))}
            </List>
          </Box>

          {data.form_input_single_row && (
            <SignupForm
              data={data.form_input_single_row}
              sx={{
                form: {
                  display: {
                    xs: 'block',
                    mobile: 'flex'
                  },
                  button: {
                    mt: {
                      xs: 1,
                      mobile: 0
                    },
                    width: {
                      xs: '100%',
                      mobile: 'auto',
                      tablet: 'auto'
                    }
                  }
                },
                width: { xs: '100%', tablet: 500 },
                mt: { xs: 4, mobile: 7.5, laptop: 6 }
              }}
            />
          )}
        </Box>
      </Box>

      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            mt: { xs: 18.5, mobile: 16.5, laptop: 10.5 },
            position: 'relative'
          }}>
          <Typography
            sx={{
              background:
                'radial-gradient(100% 7106.9% at 4.49% 0%, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0.035) 100%)',
              backdropFilter: 'blur(10px)',
              border: 1,
              borderColor: 'border.main',
              borderRadius: 4.5,
              color: 'text.secondary',
              fontSize: { xs: 18, mobile: 22 },
              lineHeight: 1.6,
              pb: { xs: 4.5, mobile: 9, laptop: 9.5 },
              pt: { xs: 7, mobile: 13, laptop: 10 },
              px: { xs: 2, mobile: 7, laptop: 4 },
              textAlign: 'center'
            }}>
            {data.testimonial.clientcontent}
          </Typography>

          <Box
            component='img'
            src='/images/quotes.svg'
            alt='quotes'
            sx={{
              top: { xs: -108, mobile: -60, laptop: -84 },
              position: 'absolute'
            }}
          />
        </Box>

        <Box
          sx={{
            width: 96,
            height: 96,
            mt: { xs: -1, mobile: -6 },
            zIndex: 1
          }}>
          <Image url={data.testimonial.clientimage.asset?.url} />
        </Box>

        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: { xs: 12, mobile: 18 },
            lineHeight: 1.4,
            maxWidth: { xs: 170, mobile: 270 },
            mt: 3.5,
            textAlign: 'center'
          }}>
          - {data.testimonial.clientname}
          <br />
          {data.testimonial.clientdesignation}
        </Typography>
      </Box>
    </Box>

    <Box className='section-divider' />
  </Box>
)
